import React, { useEffect, useState } from 'react';
import { Grid, Card, Typography } from '@mui/material';
import { connect } from 'react-redux';
import * as menuActions from '../store/actions/breadcrumb';
import PropTypes from 'prop-types';
import ChartSwitcher from './ChartSwitcher';
import styled from 'styled-components';
import SetPassword from './SignIn/SetPassword';
import * as dashboardActions from '../store/actions/dashboard';
import * as charityActions from '../store/actions/charitableActivity';
import * as businessUnitActions from '../store/actions/businessUnit';
import moment from 'moment';
import {calulateChartView, calulateTableView, calulateTableViewForLocation} from '../components/Utils'
import { useLogout } from '../components/Utils';
import Chart1 from './Chart1';
import {utils,writeFile} from 'xlsx';
import { useTranslation } from 'react-i18next';

const Dashboard = ({
  setBreadcrumb, 
  getBusinessCountryDetails, 
  getBusinessLocationDetails,
  getBusinessDetails,
  businessDetails,
  countryDetails,
  busineeUnitlocationDetails,
  dashboardDetails,
  getDashboardDetails,
  getYearList,
  yearList,
  getBUnitFilterDetails, 
  bunitFilterList,
  getAllCountriesAndCurrency,
  countriesList
}) => {
  const { t } = useTranslation('common');
  const onLogout = useLogout();

  const [dashboardData, setDashboardData] = useState(null);
  const [businessUnitChartData, setBusinessUnitChartData] = useState(null);
  const [locationCharViewtData, setLocationCharViewtData] = useState(null);
  const [yearData, setYearData] = useState(null);

  const [globalViewTableData, setGlobalViewTableData] = useState([])
  const [businessViewTableData, setBusinessViewTableData] = useState([])
  const [localtionViewTable, setLocationViewTable] = useState([])

  const [filterDropdown1, setFilterDropdown1] = useState(moment().startOf('year')?.format("YYYY"));
  const [filterDropdown2, setFilterDropdown2] = useState(moment().startOf('year')?.format("YYYY"));
  const [filterDropdown3, setFilterDropdown3] = useState(moment().startOf('year')?.format("YYYY"));

  const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));

  const [filterList, setFilterList] = useState([]);
  const [selectedLocationNames, setSelectedLocationNames] = useState([]);
  const [selectedLocationNames2, setSelectedLocationNames2] = useState([]);
  const [selectedLocationNames3, setSelectedLocationNames3] = useState([]);
  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState([]);
  const [selectedCountryNames, setSelectedCountryNames] = useState([]);
  const [countryList, setCountryList] = useState([]);

  useEffect(()=>{
    getYearList();
    getBUnitFilterDetails();
  },[])

  useEffect(()=>{
    if(yearList && yearList?.status === 200){
      if(yearList?.data?.length > 0) {
        setYearData(yearList?.data)
      } else {
        setYearData([moment().startOf('year')?.format("YYYY")])
      }
    }else if(yearList && yearList?.status === 401){
      onLogout();
    }
  },[yearList])

  const defaultFilterLoc = filterList
  ?.flatMap(item => item?.businessLocation?.filter(location => location?.isSelected) || [])
  ?.map(location => ({
    value: location?.id,
    label: location?.locationName,
  }));

  useEffect(()=>{
    if(bunitFilterList && bunitFilterList?.status === 200){
      const dataArr = bunitFilterList?.data || []
      setFilterList(dataArr);
      const defaultFilter = dataArr?.map((businessUnit) => ({
        label: businessUnit?.businessUnitName,
        value: businessUnit?.businessUnitId,
      }));
      setSelectedLocationNames(defaultFilterLoc)
      setSelectedLocationNames2(defaultFilterLoc)
      setSelectedLocationNames3(defaultFilterLoc)
    } else if(bunitFilterList && bunitFilterList?.status === 401){ 
      onLogout();
    }
  },[bunitFilterList, filterList])

  const handleLocationChange = (selectedOptions) => {
    setSelectedLocationNames(selectedOptions);
  };
  const handleLocationChange2 = (selectedOptions) => {
    setSelectedLocationNames2(selectedOptions);
  };
  const handleCountryChange = (selectedOptions) => {
    setSelectedCountryNames(selectedOptions);
  }
  const handleLocationChange3 = (selectedOptions) => {
    setSelectedLocationNames3(selectedOptions);
  };

  const handleFilterChange1 = (value) => {
    setFilterDropdown1(value);
  };

  const handleFilterChange2 = (value) => {
    setFilterDropdown2(value);
  };

  const handleFilterChange3 = (value) => {
    setFilterDropdown3(value);
  };

  const handleBusinessUnitChange = (selectedOptions) => {
    setSelectedBusinessUnits(selectedOptions);
  };

  const onSetPassword = () => {}

  const getStartandEndDate = (selectedValue) => {
    let newStartDate = '';
    let newEndDate = '';
    if(selectedValue === "ALL"){
      newStartDate = "1900-01-01";
      newEndDate = moment(new Date()).endOf('year').format("YYYY-MM-DD");
    } else {
      newStartDate = moment(`${selectedValue}-01-01`).startOf('year').format("YYYY-MM-DD");
      newEndDate = moment(`${selectedValue}-12-31`).endOf('year').format("YYYY-MM-DD");
    }
    return { newStartDate, newEndDate };
  };

  const calulateGlobalView = async (data) => {
    const sortedData = data?.sort((a, b) => a?.countryName.localeCompare(b?.countryName));
    const finalObject = await calulateChartView(sortedData, 'countryName')
    const tableData = await calulateTableView(data, 'countryName')
    const globalChartData = { globalChartDataObj: finalObject }
    setDashboardData(globalChartData)
    setGlobalViewTableData(tableData)
  }

  const calulateBusinnessView = async (data) => {
    const sortedData = data?.sort((a, b) => a?.businessUnitName.localeCompare(b?.businessUnitName));
    const finalObject = await calulateChartView(sortedData, 'businessUnitName')
    const tableData = await calulateTableView(data, 'businessUnitName')
    setBusinessUnitChartData(finalObject)
    setBusinessViewTableData(tableData)
  }

  const calulateLocationView = async (data) => {
    const sortedData = data?.sort((a, b) => a?.locationName.localeCompare(b?.locationName));
    const finalObject = await calulateChartView(sortedData, 'locationName')
    const tableData = await calulateTableViewForLocation(data, 'locationName')
    setLocationCharViewtData(finalObject)
    setLocationViewTable(tableData)
  }

  useEffect(()=>{
    getAllCountriesAndCurrency()
  },[])

  useEffect(() => {
    if(countriesList && countriesList?.status === 200){
      const countryNameArray = countriesList?.data?.map(item => {
        return { label: item?.countryName, value: item?.id }
      }).sort((a, b) => a?.label?.localeCompare(b?.label));
      setCountryList(countryNameArray);
    } else if(countriesList && countriesList?.status === 401){ 
      onLogout();
    }
  }, [countriesList?.data]);

  useEffect(()=>{
    const one = getStartandEndDate(filterDropdown1);
    const payload = {
      fromDate: one?.newStartDate,
      toDate: one?.newEndDate,
      selectedCountry: selectedCountryNames?.map(item => item.value) || ''
    }
    getBusinessCountryDetails(payload)
  },[filterDropdown1, selectedLocationNames, selectedCountryNames])

  useEffect(()=>{
    const two = getStartandEndDate(filterDropdown2)
    const payload = {
      fromDate: two?.newStartDate,
      toDate: two?.newEndDate,
      selectedBusinessUnits: selectedBusinessUnits?.map(item => item.value) || ''
    }
    getBusinessDetails(payload);
  },[filterDropdown2, selectedLocationNames2, selectedBusinessUnits])

  useEffect(()=>{
    const three = getStartandEndDate(filterDropdown3)
    const payload = {
      fromDate: three?.newStartDate,
      toDate: three?.newEndDate,
      selectedLocation: selectedLocationNames3?.map(item => item.value) || ''
    }
    getBusinessLocationDetails(payload)
  },[filterDropdown3, selectedLocationNames3])

  useEffect(() => {
    if(businessDetails && businessDetails.status === 200) {
      calulateGlobalView(businessDetails?.data)
    } else if (businessDetails && businessDetails.status === 401){
      onLogout();
    }
  }, [businessDetails]);

  useEffect(() => {
    if(busineeUnitlocationDetails && busineeUnitlocationDetails.status === 200) {
      calulateBusinnessView(busineeUnitlocationDetails?.data)
    } else if (busineeUnitlocationDetails && busineeUnitlocationDetails.status === 401){
      onLogout();
    }
  }, [busineeUnitlocationDetails]);

  useEffect(() => {
    if(countryDetails && countryDetails.status === 200) {
      calulateLocationView(countryDetails?.data)
    } else if(countryDetails && countryDetails.status === 401) {
      onLogout();
    }
  }, [countryDetails]);

  const globalChartData = {
    height: { min: 650, max: 750 },
    data: {
      labels: dashboardData?.globalChartDataObj?.["labels"],
      datasets: [
        {
          label: t('Martinrea Funds in CAD (Charity Only)'),
          backgroundColor: '#0F2D52',
          borderRadius: 5,
          borderWidth: 1,
          data: dashboardData?.globalChartDataObj?.['martinreaFund'],
        },
        {
          label: t('Martinrea Funds in CAD'),
          backgroundColor: '#1A5276',
          borderRadius: 5,
          borderWidth: 1,
          data: dashboardData?.globalChartDataObj?.['martinreaFundCombined'],
        },
        {
          label: t('Employee Funds in CAD (Charity Only)'),
          backgroundColor: '#6CC133',
          borderRadius: 5,
          data: dashboardData?.globalChartDataObj?.['empoyeeFund'],
        },
        {
          label: t('Employee Funds in CAD'),
          backgroundColor: '#A9D96C',
          borderRadius: 5,
          data: dashboardData?.globalChartDataObj?.['empoyeeFundCombined'],
        },
      ],
    },
  };

  const BusinessUnitChartData = {
    height: { min: 700, max: 1000 },
    data: {
      labels: businessUnitChartData && businessUnitChartData.labels,
      datasets: [
        {
          label: t('Martinrea Funds in CAD (Charity Only)'),
          data: businessUnitChartData && businessUnitChartData.martinreaFund,
          borderRadius: 5,
          backgroundColor: '#0F2D52',
        },
        {
          label: t('Martinrea Funds in CAD'),
          data: businessUnitChartData && businessUnitChartData.martinreaFundCombined,
          borderRadius: 5,
          backgroundColor: '#1A5276',
        },
        {
          label: t('Employee Funds in CAD (Charity Only)'),
          data: businessUnitChartData && businessUnitChartData.empoyeeFund,
          borderRadius: 5,
          backgroundColor: '#6CC133',
        },
        {
          label: t('Employee Funds in CAD'),
          data: businessUnitChartData && businessUnitChartData.empoyeeFundCombined,
          borderRadius: 5,
          backgroundColor: '#A9D96C',
        },
      ],
    },
  };

  const locationChartData = {
    height: { min: 900, max: 1000 },
    data: {
      labels: locationCharViewtData?.labels,
      datasets: [
        {
          label: t('Martinrea Funds in CAD (Charity Only)'),
          backgroundColor: '#0F2D52',
          borderRadius: 5,
          borderWidth: 1,
          data: locationCharViewtData?.martinreaFund,
        },
        {
          label: t('Martinrea Funds in CAD'),
          backgroundColor: '#1A5276',
          borderRadius: 5,
          borderWidth: 1,
          data: locationCharViewtData?.martinreaFundCombined,
        },
        {
          label: t('Employee Funds in CAD (Charity Only)'),
          backgroundColor: '#6CC133',
          borderRadius: 5,
          data: locationCharViewtData?.empoyeeFund,
        },
        {
          label: t('Employee Funds in CAD'),
          backgroundColor: '#A9D96C',
          borderRadius: 5,
          data: locationCharViewtData?.empoyeeFundCombined,
        },
      ],
    },
  };

  const GlobalViewTableData = {
    data: {
      header: [
        t('Country'),
        t('Martinrea Funds in CAD (Charity Only)'),
        t('Martinrea Funds in CAD'),
        t('Employee Funds in CAD (Charity Only)'),
        t('Employee Funds in CAD'),
        t('Volunteer Hours (Charity Only)'),
        t('Volunteer Hours')
      ],
      body: globalViewTableData
    }
  }

  const BusinessViewTableData = {
    data: {
      header: [
        t('Business Unit'),
        t('Martinrea Funds in CAD (Charity Only)'),
        t('Martinrea Funds in CAD'),
        t('Employee Funds in CAD (Charity Only)'),
        t('Employee Funds in CAD'),
        t('Volunteer Hours (Charity Only)'),
        t('Volunteer Hours')
      ],
      body: businessViewTableData
    }
  }

  const locationViewTableData = {
    data: {
      header: [
        t('Locations'),
        t('Martinrea Funds in CAD (Charity Only)'),
        t('Martinrea Funds in CAD'),
        t('Martinrea Funds in Local Currency (Charity Only)'),
        t('Martinrea Funds in Local Currency'),
        t('Employee Funds in CAD (Charity Only)'),
        t('Employee Funds in CAD'),
        t('Employee Funds in Local Currency (Charity Only)'),
        t('Employee Funds in Local Currency'),
        t('Volunteer Hours (Charity Only)'),
        t('Volunteer Hours')
      ],
      body: localtionViewTable
    }
  }

  useEffect(() => {
    setBreadcrumb(t('Dashboard'))
  }, []);

  const onChartExport = (data, title, year, locationNames, lastOptions) => {
    const locationNamesFilter = locationNames.map((item) => item.label).join(', ');
    let countryNameFilter = null;
    const translatedHeadings = {
      "Export Date": t("Export Date"),
      "Year": t("Year"),
      "Country": t("Country"),
      "Business Unit": t("Business Unit"),
      "Location": t("Locations"),
      "Martinrea Funds in CAD": t("Martinrea Funds in CAD (Charity Only)"),
      "Martinrea Funds in CAD Combined": t("Martinrea Funds in CAD"),
      "Employee Funds in CAD": t("Employee Funds in CAD (Charity Only)"),
      "Employee Funds in CAD Combined": t("Employee Funds in CAD"),
      "Volunteer Hours": t("Volunteer Hours (Charity Only)"),
      "Volunteer Hours Combined": t("Volunteer Hours"),
      "Martinrea Funds in Local Currency": t("Martinrea Funds in Local Currency (Charity Only)"),
      "Martinrea Funds in Local Currency Combined": t("Martinrea Funds in Local Currency"),
      "Employee Funds in Local Currency": t("Employee Funds in Local Currency (Charity Only)"),
      "Employee Funds in Local Currency Combined": t("Employee Funds in Local Currency"),
      "Total Records": t("Total Records")
    };
    let bunitFilter = null;
    const wb = utils.book_new();
    let ws = null;

    if (title === "Regional-View-Report") {
      countryNameFilter = lastOptions.map((item) => item.label).join(', ');
      ws = utils.json_to_sheet([{
        [translatedHeadings["Export Date"]]: new Date(),
        [translatedHeadings["Year"]]: year,
        [translatedHeadings["Country"]]: lastOptions?.length === 0 ? "All Countries" : countryNameFilter,
        [translatedHeadings["Location"]]: locationNames?.length === 0 ? "All Locations" : locationNamesFilter
      }]);
    } else if (title === "Business-Unit-View-Report") {
      bunitFilter = lastOptions.map((item) => item.label).join(', ');
      ws = utils.json_to_sheet([{
        [translatedHeadings["Export Date"]]: new Date(),
        [translatedHeadings["Year"]]: year,
        [translatedHeadings["Business Unit"]]: lastOptions?.length === 0 ? "All Business Units" : bunitFilter,
        [translatedHeadings["Location"]]: locationNames?.length === 0 ? "All Locations" : locationNamesFilter
      }]);
    } else {
      ws = utils.json_to_sheet([{
        [translatedHeadings["Export Date"]]: new Date(),
        [translatedHeadings["Year"]]: year,
        [translatedHeadings["Location"]]: locationNames?.length === 0 ? "All Locations" : locationNamesFilter
      }]);
    }

    const defaultColumnWidth = { wpx: 50 };
    Object.keys(data?.data?.body[0] || {}).forEach((key, index) => {
      ws['!cols'] = ws['!cols'] || [];
      ws['!cols'].push({ wch: defaultColumnWidth.wpx });
    });

    utils.sheet_add_json(ws, [{ [translatedHeadings['Total Records']]: data?.data?.body?.length }], { origin: "A5" })
    utils.sheet_add_json(ws, data?.data?.body?.map((item) => {
      if (title === "Regional-View-Report") {
        const csvdata = { [translatedHeadings["Country"]]: item.country };
        csvdata[translatedHeadings['Martinrea Funds in CAD']] = item.martinreaFunds;
        csvdata[translatedHeadings['Martinrea Funds in CAD Combined']] = item.martinreaFundsCombined;
        csvdata[translatedHeadings['Employee Funds in CAD']] = item.employeeFunds;
        csvdata[translatedHeadings['Employee Funds in CAD Combined']] = item.employeeFundsCombined;
        csvdata[translatedHeadings['Volunteer Hours']] = item.volunteerHour;
        csvdata[translatedHeadings['Volunteer Hours Combined']] = item.volunteerHourCombined;
        return csvdata;
      } else if (title === "Business-Unit-View-Report") {
        const csvdata = { [translatedHeadings["Business Unit"]]: item.country };
        csvdata[translatedHeadings['Martinrea Funds in CAD']] = item.martinreaFunds;
        csvdata[translatedHeadings['Martinrea Funds in CAD Combined']] = item.martinreaFundsCombined;
        csvdata[translatedHeadings['Employee Funds in CAD']] = item.employeeFunds;
        csvdata[translatedHeadings['Employee Funds in CAD Combined']] = item.employeeFundsCombined;
        csvdata[translatedHeadings['Volunteer Hours']] = item.volunteerHour;
        csvdata[translatedHeadings['Volunteer Hours Combined']] = item.volunteerHourCombined;
        return csvdata;
      } else if (title === "Location-View-Report") {
        const csvdata = { [translatedHeadings["Location"]]: item.country };
        csvdata[translatedHeadings['Martinrea Funds in CAD']] = item.martinreaFunds;
        csvdata[translatedHeadings['Martinrea Funds in CAD Combined']] = item.martinreaFundsCombined;
        csvdata[translatedHeadings['Martinrea Funds in Local Currency']] = item.martinreaFundsInLocal;
        csvdata[translatedHeadings['Martinrea Funds in Local Currency Combined']] = item.martinreaFundsInLocalCombined;
        csvdata[translatedHeadings['Employee Funds in CAD']] = item.employeeFunds;
        csvdata[translatedHeadings['Employee Funds in CAD Combined']] = item.employeeFundsCombined;
        csvdata[translatedHeadings['Employee Funds in Local Currency']] = item.employeeFundsInLocal;
        csvdata[translatedHeadings['Employee Funds in Local Currency Combined']] = item.employeeFundsInLocalCombined;
        csvdata[translatedHeadings['Volunteer Hours']] = item.volunteerHour;
        csvdata[translatedHeadings['Volunteer Hours Combined']] = item.volunteerHourCombined;
        return csvdata;
      } else {
        return { ...item };
      }
    }), { origin: "A8" })

    utils.book_append_sheet(wb, ws, 'Sheet1');
    writeFile(wb, title + `.xlsx`);
  }

  const businessUnitOptions = filterList
    ?.map((businessUnit) => ({
      label: businessUnit.businessUnitName,
      value: businessUnit.businessUnitId,
    }))
    .sort((a, b) => a?.label?.localeCompare(b?.label));

  const defaultFilter = businessUnitOptions?.map(item => item?.value);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} xl={6} lg={6} md={6}>
          <h1 className='page-heading'><b>{t("Dashboard")}</b></h1>
        </Grid>
      </Grid>
      <hr className='blue-border' />
      <Grid container spacing={2} className='mt-20'>
        <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
          <Card className='kpibox'>
            <ChartSwitcher
              title={t("Regional View")}
              id="regionalView"
              chartData={globalChartData}
              tableData={GlobalViewTableData}
              filterDropdown={filterDropdown1}
              yearData={yearData}
              handleFilterChange={handleFilterChange1}
              filterList={filterList}
              onExportReport={()=>{onChartExport(GlobalViewTableData, "Regional-View-Report", filterDropdown1, selectedLocationNames, selectedCountryNames)}}
              handleLocationChange={handleLocationChange}
              countryList={countryList}
              selectedLocationNames={selectedLocationNames}
              handleCountryChange={handleCountryChange}
              selectedCountryNames={selectedCountryNames}
            />
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
          <Card className='kpibox'>
            <ChartSwitcher
              title={t("Business Unit View")}
              id="businessUnitView"
              type="stackedBar"
              chartData={BusinessUnitChartData}
              tableData={BusinessViewTableData}
              filterDropdown={filterDropdown2}
              yearData={yearData}
              handleFilterChange={handleFilterChange2}
              filterList={filterList}
              onExportReport={()=>{onChartExport(BusinessViewTableData, "Business-Unit-View-Report", filterDropdown2, selectedLocationNames2, selectedBusinessUnits)}}
              handleLocationChange={handleLocationChange2}
              selectedLocationNames={selectedLocationNames2}
              selectedBusinessUnits={selectedBusinessUnits}
              handleBusinessUnitChange={handleBusinessUnitChange}
            />
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={2} className='mt-20'>
        <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
          <Card className='kpibox'>
            <ChartSwitcher
              id="locationView"
              title={t("Location View")}
              type="bar"
              chartData={locationChartData}
              tableData={locationViewTableData}
              filterDropdown={filterDropdown3}
              yearData={yearData}
              handleFilterChange={handleFilterChange3}
              onExportReport={()=>{onChartExport(locationViewTableData, "Location-View-Report", filterDropdown3, selectedLocationNames3)}}
              filterList={filterList}
              handleLocationChange={handleLocationChange3}
              selectedLocationNames={selectedLocationNames3}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = (state) => ({
  businessDetails: state.dashboard.businessDetails,
  countryDetails: state.dashboard.countryDetails,
  busineeUnitlocationDetails: state.dashboard.busineeUnitlocationDetails,
  yearList: state.dashboard.yearList,
  bunitFilterList: state.charitableActivity.bunitFilterList,
  countriesList: state.businessUnit.countriesList
})

const mapDispatchToProps = (dispatch) => {
  return {
    setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
    getBusinessCountryDetails: (data) => dispatch(dashboardActions.getBusinessCountryDetails(data)),
    getAllCountriesAndCurrency: (data) => dispatch(businessUnitActions.getAllCountriesAndCurrency(data)),
    getBusinessLocationDetails: (data) => dispatch(dashboardActions.getBusinessLocationDetails(data)),
    getBusinessDetails: (data) => dispatch(dashboardActions.getBusinessDetails(data)),
    getYearList: () => dispatch(dashboardActions.getYearList()),
    getBUnitFilterDetails: () => dispatch(charityActions.getBUnitFilterDetails()),
  };
};

Dashboard.propTypes = {
  setBreadcrumb: PropTypes.func.isRequired,
  getBusinessCountryDetails: PropTypes.func.isRequired,
  getAllCountriesAndCurrency: PropTypes.func.isRequired,
  getBusinessLocationDetails: PropTypes.func.isRequired,
  getBusinessDetails: PropTypes.func.isRequired,
  getYearList: PropTypes.func.isRequired,
  getBUnitFilterDetails: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);